/* globals $ */
import { registerClass } from 'libs/ComponentLoader'

import {
  search,
  SEARCH_RESULTS
} from 'libs/rcmSearchApi'

import './styles.scss'

class ResultSorting {
  constructor (element) {
    this.$el = $(element)

    this.$select = this.$el.find('.resultSorting-dropdown')
    this.allVals = []
    this.$select.find('option').each((index, element) => {
      const $element = $(element)
      this.allVals[$element.val()] = $element.html()
    })

    this.updateSort = this.updateSort.bind(this)
    this.changeSorting = this.changeSorting.bind(this)

    this.$select.selectmenu({
      position: {
        my: 'right top+7',
        at: 'center bottom',
        collision: 'none'
      },
      classes: {
        'ui-selectmenu-button': 'resultSorting-selectMenuButton',
        'ui-selectmenu-menu': 'resultSorting-selectMenu'
      },
      width: false
    })

    this.$select.on('selectmenuchange', this.changeSorting)

    search.on(SEARCH_RESULTS, this.updateSort)
  }

  updateSort () {
    const {
      sortBy,
      sortOrder
    } = search

    let val = ''

    if (sortBy) {
      val = sortBy
    }

    if (sortOrder) {
      val += ':' + sortOrder
    } else {
      val += ':asc'
    }

    if (this.allVals[val]) {
      this.$select.val(val)
      this.$select.selectmenu('refresh')
    }
  }

  changeSorting () {
    const sortVal = this.$select.find(':selected').val().split(':')
    const sortDirection = (sortVal.length > 1) ? sortVal[1] : ''
    const sortAttribute = sortVal[0]

    search.sort(sortAttribute, sortDirection)
  }
}

registerClass('ResultSorting', ResultSorting)
